<template lang="html">
  <div class="monitor">
    <v-header :name="name"></v-header>
    <div class="container">
      <div class="area-list">
        <div class="item" :class="['item',{['active']: index == 2}]" v-for="(item,index) in areaList" :key="index">{{item}}</div>
      </div>
      <div class="bottom">
        <div class="left">
          <div class="left-item left-item1">
            {{baseDetailList[activeItem].baseName}}
          </div>
          <div class="left-item">
            <p class="label">基地负责人</p>
            <p class="val">{{baseDetailList[activeItem].name}}</p>
          </div>
          <div class="left-item">
            <p class="label">联系电话</p>
            <p class="val">{{baseDetailList[activeItem].phone}}</p>
          </div>
          <div class="left-item">
            <p class="label">管理机构</p>
            <p class="val">{{baseDetailList[activeItem].company}}</p>
          </div>
          <div class="left-item">
            <p class="label">基地面积</p>
            <p class="val">{{baseDetailList[activeItem].total}}</p>
          </div>
          <div class="left-item">
            <p class="label">承包时间</p>
            <p class="val">{{baseDetailList[activeItem].time}}</p>
          </div>
          <div class="left-item">
            <p class="label">基地地址</p>
            <p class="val">{{baseDetailList[activeItem].region}}</p>
          </div>
        </div>
        
        <div class="middle">
          <div class="item">
            <v-lines></v-lines>
          </div>
          <div class="item">
            <v-line tit="年平均降雨量"></v-line>
          </div>
          <div class="item">
            <v-line tit="无霜期"></v-line>
          </div>
          <div class="item">
            <v-line tit="年平均日照时长"></v-line>
          </div>
        </div>

        <div class="right">
          <v-map @indexChange="indexChange"></v-map>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import header from 'components/common/header'
import line from 'components/industryInformation/line'
import lines from 'components/industryInformation/lines'
import map from 'components/industryInformation/map'
export default {
  data() {
    const that = this;
    return {
      name: '田阳县农业大脑——基地数据',
      areaList: ['右江区', '靖西市', '田阳县', '田东县', '平果县', '德保县', '那坡县', '凌云县', '乐业县', '田林县', '西林县', '隆林县'],
      baseDetailList: [
        { baseName: '田阳县基地', name: '周*礼', phone: '136****2930', company: '田阳县蔬心特色农产品经营部', total: '100亩', time: '2016.10至2020.10', region: '百色市田阳县' },
        { baseName: '镇巴基地', name: '李*雨', phone: '132****3212', company: '广西百色盛泰和农业有限公司', total: '200亩', time: '2017.1至2021.12', region: '百色市田阳县' },
        { baseName: '五村基地', name: '梁*欣', phone: '182****3012', company: '广西田阳骄阳农产品贸易有限公司', total: '140亩', time: '2017.1至2027.12', region: '百色市田阳县' }
      ],
      activeItem: 0

    }
  },
  mounted() {
  },
  methods: {
    // 下标改变事件
    indexChange(newIndex) {
      this.activeItem = newIndex;
    }
  },
  components: {
    'v-header': header,
    'v-line': line,
    'v-lines': lines,
    'v-map': map
  }
}

</script>

<style lang="stylus" scoped>
.monitor {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: url('../../../static/img/common/bg.png');
  background-size: 100% 100%;
}

.container {
  height: 100%;
  padding: 26px 30px 0;
  box-sizing: border-box;

  .area-list {
    display: flex;
    justify-content: center;

    .item {
      width: 126px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      background: url('../../../static/img/industryInformation/word-bg.png') no-repeat;
      color: #fff;
      font-size: 22px;
      margin-right: 29px;
    }

    .active {
      background: url('../../../static/img/industryInformation/word-bg1.png') no-repeat;
    }
  }

  .bottom {
    height: 816px;
    display: flex;
    margin-top: 26px;

    .left {
      width: 204px;
      flex-direction: column;
      color: #fff;
      font-size: 20px;

      .left-item {
        width: 100%;
        height: 100px;
        background: url('../../../static/img/industryInformation/detail-bg.png') no-repeat;
        margin-bottom: 18px;
        padding-left: 24px;
        padding-top: 20px;
        box-sizing: border-box;

        .label {
          color: #00A4FF;
          margin-bottom: 10px;
        }

        .val {
          font-size: 16px;
        }
      }

      .left-item1 {
        padding-top: 36px;
        height: 108px;
        background: url('../../../static/img/industryInformation/tit-bg.png') no-repeat;
        width: 204px;
      }
    }

    .middle {
      width: 382px;
      mmargin: 0 22px;

      .item {
        margin-bottom: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?5a0342db